import removeAccents from "remove-accents";

const hourlyRateFormatter = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const getTemplateTitle = (template) =>
    template?.name || template?.title || "";

// Legacy templates stored the qualification in `title`.
export const getTemplateQualification = (template) =>
    template?.qualification || template?.title || "";

// "Le Marin, Martinique": only a populated address carries a city.
export const formatTemplateCity = (location) => {
    if (!location || typeof location !== "object") return "";
    return [location.city, location.department]
        .map((part) => (typeof part === "string" ? part.trim() : ""))
        .filter(Boolean)
        .join(", ");
};

export const formatHourlyRate = (wage) =>
    typeof wage === "number" && Number.isFinite(wage)
        ? `${hourlyRateFormatter.format(wage)}€`
        : "";

// NFC first: remove-accents only maps precomposed characters, so text stored
// decomposed (pasted from macOS) would keep its combining accent.
const normalizeSearchText = (value) =>
    typeof value === "string"
        ? removeAccents(value.normalize("NFC")).toLowerCase()
        : "";

// Every word must match, but each one may hit a different field, so
// "cariste marin" finds a forklift template located in Le Marin.
export const filterMissionTemplates = (templates, query) => {
    const list = Array.isArray(templates) ? templates : [];
    const words = normalizeSearchText(query).split(/\s+/).filter(Boolean);
    if (words.length === 0) return list;
    return list.filter((template) => {
        const searchableText = normalizeSearchText(
            [
                getTemplateTitle(template),
                getTemplateQualification(template),
                formatTemplateCity(template?.location),
            ].join(" ")
        );
        return words.every((word) => searchableText.includes(word));
    });
};
